import React from 'react';
import { ContentfulMedia, parseSectionItem } from '@wbk/contentful';
import { WebSection } from '@wbk/contentful/api';
import { Button, Typography } from '@wbk/ui';
import { Link } from '@wbk/config';
import ScrollTitle from '@/components/ui/ScrollTitle';
import useLocalization from '@/context/localization/useLocalization';

const ZoneCategories: React.FC<{ section: WebSection }> = ({ section }) => {
  const { locale } = useLocalization();

  return (
    <div className='container-padding container'>
      <div className='container px-3 lg:space-y-12 xl:px-0'>
        <div className='mb-12'>
          <ScrollTitle title={section.title} className='max-w-lg' />
        </div>

        <div className='flex w-full flex-wrap justify-center gap-4 md:w-auto md:gap-6'>
          {section.contentCollection?.items?.map((item) => {
            const parsedItem = parseSectionItem({ item, locale });

            if (!parsedItem) return null;

            const isLink = !!parsedItem.href && parsedItem.href !== '#';
            const isExternal = isLink && parsedItem.href?.startsWith('http');

            return (
              <Button
                key={parsedItem.id}
                as={isLink ? Link : 'div'}
                href={parsedItem.href ? `${parsedItem.href}` : '#'}
                target={isExternal ? '_blank' : undefined}
                className='!rounded-L group relative h-[216px] w-[calc(50%-8px)] cursor-pointer overflow-hidden border border-b-0 border-white/20 bg-gray-900 transition-all duration-300 hover:shadow-2xl md:w-[193px]'
              >
                <ContentfulMedia
                  media={parsedItem.image11}
                  className='absolute inset-0 h-full w-full object-cover transition-transform duration-300'
                />

                <div className='absolute -inset-2 bg-gradient-to-t from-black/100 via-black/40 to-transparent' />

                <div className='absolute bottom-0 left-0 right-0 p-3 md:p-4'>
                  <Typography variant='body-M' className='line-clamp-2 font-semibold'>
                    {parsedItem.title}
                  </Typography>
                </div>

                <div className='absolute inset-0 bg-blue-500/10 opacity-0 transition-opacity duration-300 group-hover:opacity-100' />
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ZoneCategories;
